export default __webpack_public_path__ + "static/media/dollar_icon_b.654a6513.svg";